export interface EEGViewerSessionReviewConfig {
  sensitivity_value?: number;
  time_scale?: number;
}

export function buildEEGViewerSessionReviewConfigKey(
  userId: string,
  recordingId: string,
): string {
  const safeUserId = userId.trim() || "anonymous";
  const safeRecordingId = recordingId.trim();
  return `eeg-viewer-session-review:${safeUserId}:${safeRecordingId}`;
}

export function readEEGViewerSessionReviewConfig(
  userId: string,
  recordingId: string,
): EEGViewerSessionReviewConfig | null {
  if (typeof window === "undefined") return null;
  const key = buildEEGViewerSessionReviewConfigKey(userId, recordingId);
  try {
    const raw = window.sessionStorage.getItem(key);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as EEGViewerSessionReviewConfig;
    if (!parsed || typeof parsed !== "object") return null;
    return parsed;
  } catch {
    return null;
  }
}

export function writeEEGViewerSessionReviewConfig(
  userId: string,
  recordingId: string,
  patch: EEGViewerSessionReviewConfig,
): void {
  if (typeof window === "undefined") return;
  const key = buildEEGViewerSessionReviewConfigKey(userId, recordingId);
  const previous = readEEGViewerSessionReviewConfig(userId, recordingId) ?? {};
  const next: EEGViewerSessionReviewConfig = {
    ...previous,
    ...patch,
  };
  try {
    window.sessionStorage.setItem(key, JSON.stringify(next));
  } catch {
    // ignore storage failures
  }
}
